Namespace 'Customer.Reports'

class Customer.Reports.OperatorAvailabilityReport extends Backbone.Model
  url: '/customer/operator_availability/execute_report'
  defaults:
    last_updated: null

  operators: ->
    @_operators ||= new Customer.Reports.OperatorAvailabilityReportItemCollection([])

  metrics: ->
    @_metrics ||= new Customer.Reports.OperatorAvailabilityReportMetrics()

  lastUpdated: ->
    @get 'last_updated'

  parse: (response) ->
    @operators().reset response.operators
    @metrics().reset response.metrics
    {last_updated: Date.create response.last_updated}
